import { BaseApi } from '@shared/config';
import type { GetEconomicActivitiesResponse } from './types';

class EconomicActivityApi extends BaseApi {
  getEconomicActivities = (): Promise<GetEconomicActivitiesResponse> => {
    return this.instance.get('/economic-activities');
  };
}

export const economicActivityApi = new EconomicActivityApi();
